import React from 'react';
import { X, Upload, FileJson, AlertCircle } from 'lucide-react';

const ImportProductsModal = ({
    show,
    onClose,
    importMode,
    setImportMode,
    importFile,
    onFileSelect,
    onConfirm,
    fileInputRef
}) => {
    if (!show) return null;

    return (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-50">
            <div className="bg-gray-900 rounded-lg border border-gray-800 w-full max-w-lg">
                <div className="p-6 border-b border-gray-800 flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <Upload className="w-6 h-6 text-purple-400" />
                        <h2 className="text-xl font-bold">Import Products</h2>
                    </div>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-white transition-colors"
                    >
                        <X className="w-5 h-5" />
                    </button>
                </div>

                <div className="p-6 space-y-4">
                    {/* Import Mode Selection */}
                    <div>
                        <label className="block text-sm font-medium mb-2">Import Mode</label>
                        <div className="space-y-2">
                            <label className="flex items-center gap-3 p-3 bg-gray-800 rounded-lg cursor-pointer hover:bg-gray-750 transition-colors">
                                <input
                                    type="radio"
                                    name="importMode"
                                    value="merge"
                                    checked={importMode === 'merge'}
                                    onChange={(e) => setImportMode(e.target.value)}
                                    className="w-4 h-4 text-purple-600"
                                />
                                <div>
                                    <div className="font-medium">Merge</div>
                                    <div className="text-xs text-gray-400">Keep existing products and add new ones</div>
                                </div>
                            </label>
                            <label className="flex items-center gap-3 p-3 bg-gray-800 rounded-lg cursor-pointer hover:bg-gray-750 transition-colors">
                                <input
                                    type="radio"
                                    name="importMode"
                                    value="replace"
                                    checked={importMode === 'replace'}
                                    onChange={(e) => setImportMode(e.target.value)}
                                    className="w-4 h-4 text-purple-600"
                                />
                                <div>
                                    <div className="font-medium">Replace</div>
                                    <div className="text-xs text-gray-400">Update existing products with imported data</div>
                                </div>
                            </label>
                        </div>
                    </div>

                    {/* File Selection */}
                    <div>
                        <label className="block text-sm font-medium mb-2">Select JSON File</label>
                        <input
                            ref={fileInputRef}
                            type="file"
                            accept=".json"
                            onChange={onFileSelect}
                            className="hidden"
                        />
                        <button
                            onClick={() => fileInputRef.current?.click()}
                            className="w-full px-4 py-3 bg-gray-800 border-2 border-dashed border-gray-700 rounded-lg hover:border-purple-500 hover:bg-gray-750 transition-colors flex items-center justify-center gap-2"
                        >
                            <FileJson className="w-5 h-5 text-purple-400" />
                            <span>{importFile ? importFile.name : 'Choose file...'}</span>
                        </button>
                        <p className="text-xs text-gray-400 mt-2">Select a JSON file exported from this application</p>
                    </div>

                    {/* Import Info */}
                    {importFile && (
                        <div className="p-3 bg-blue-500/10 border border-blue-500/30 rounded-lg">
                            <div className="flex items-start gap-2">
                                <AlertCircle className="w-4 h-4 text-blue-400 mt-0.5 flex-shrink-0" />
                                <div className="text-sm text-blue-400">
                                    <div className="font-medium mb-1">File selected: {importFile.name}</div>
                                    <div className="text-xs">
                                        {importMode === 'merge'
                                            ? 'New products and builds will be added. Existing products will be kept as is.'
                                            : 'Existing products with the same ID will be updated with imported data.'}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <div className="p-6 border-t border-gray-800 flex justify-end gap-3">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-700 transition-colors"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        disabled={!importFile}
                        className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors disabled:bg-gray-700 disabled:cursor-not-allowed flex items-center gap-2"
                    >
                        <Upload className="w-4 h-4" />
                        Import
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ImportProductsModal;
